
import React from 'react';

const OceanGrid =()=> {
    return (
        <div className="gridRadioDisplay" id="sandWater">  
            <div className="gridItem gt1"></div>
            <div className="gridItem gt2"></div>
            <div className="gridItem gt3"></div>
            <div className="gridItem gt4"></div>
            <div className="gridItem gt5"></div>
            <div className="gridItem gt6"></div>
            <div className="gridItem gt7"></div>
        </div>
    )
}

export default OceanGrid;